__webpack_require__.p = "https://auth.byonde.asia/";